const HexLogo = () => (
  <svg width="32" height="36" viewBox="0 0 32 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="hexGradientFooter" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#7C3AED" />
        <stop offset="100%" stopColor="#BF7FFF" />
      </linearGradient>
    </defs>
    <path 
      d="M16 0L31.5 8.5V27.5L16 36L0.5 27.5V8.5L16 0Z" 
      fill="url(#hexGradientFooter)"
      opacity="0.3"
    />
    <path 
      d="M16 4L27.5 10.5V25.5L16 32L4.5 25.5V10.5L16 4Z" 
      fill="url(#hexGradientFooter)"
      opacity="0.5"
    />
    <path 
      d="M16 8L23.5 12.5V23.5L16 28L8.5 23.5V12.5L16 8Z" 
      fill="url(#hexGradientFooter)"
    />
    <circle cx="16" cy="18" r="3" fill="white" />
  </svg>
);

const footerLinks = {
  product: {
    title: "Product",
    links: [
      { label: "How It Works", href: "#how-it-works" },
      { label: "Ingredients", href: "#ingredients" },
      { label: "Reviews", href: "#reviews" },
      { label: "FAQ", href: "#faq" }
    ]
  },
  company: {
    title: "Company",
    links: [
      { label: "About Us", href: "#" },
      { label: "Blog", href: "#" },
      { label: "Careers", href: "#" },
      { label: "Press", href: "#" }
    ]
  },
  support: {
    title: "Support",
    links: [
      { label: "Contact Us", href: "#" },
      { label: "Shipping Info", href: "#" },
      { label: "Returns", href: "#" },
      { label: "Track Order", href: "#" }
    ]
  }
};

const Footer = () => {
  return (
    <footer 
      className="bg-nukleus-bg border-t border-white/5 pt-16 pb-8"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12 mb-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <a href="/" className="flex items-center gap-2 mb-4">
              <HexLogo />
              <span className="text-white font-bold text-lg tracking-tight">NUKLEUS</span>
            </a>
            <p className="text-white/50 text-sm leading-relaxed mb-4">
              Premium nootropics for the modern mind. Think deeper, perform better.
            </p>
            <p className="text-white/30 text-xs">
              Start from the core.
            </p>
          </div>

          {/* Link Columns */}
          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-white font-semibold mb-4">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a 
                      href={link.href}
                      className="text-white/50 hover:text-white text-sm transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* FDA Disclaimer */}
        <div className="border-t border-white/5 pt-8 mb-8">
          <p className="text-white/30 text-xs text-center max-w-3xl mx-auto leading-relaxed">
            *These statements have not been evaluated by the Food and Drug Administration. 
            This product is not intended to diagnose, treat, cure, or prevent any disease. 
            Consult your healthcare provider before use if you are pregnant, nursing, taking medication, or have a medical condition.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm">
          <p className="text-white/30">
            © {new Date().getFullYear()} NUKLEUS. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/30 hover:text-white/50 transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-white/30 hover:text-white/50 transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
